import { HOW_IT_WORKS } from "../data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const HowItWorks = () => (
    <section id="how-it-works" className="py-16 sm:py-24 lg:py-32" data-testid="how-it-works-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
            <SectionHeading
                chapter="04"
                kicker="How It Works"
                title="From first scan to a system that keeps improving."
                testid="how-it-works-heading"
            />
            <ol className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
                {HOW_IT_WORKS.map((step, i) => (
                    <Reveal key={step.num} delay={i * 0.09}>
                        <li className="relative h-full border-t-2 border-brand-brown/15 pt-7" data-testid={`how-step-${step.num}`}>
                            <span className="absolute -top-[2px] left-0 h-0.5 w-12 bg-brand-orange" aria-hidden="true" />
                            <span className="font-mono text-sm font-semibold text-brand-orange">{step.num}</span>
                            <h3 className="mt-3 font-display text-xl font-bold text-brand-brown">{step.title}</h3>
                            <p className="mt-3 text-sm leading-relaxed text-brand-muted">{step.text}</p>
                        </li>
                    </Reveal>
                ))}
            </ol>
        </div>
    </section>
);
